import $ from 'jquery'
import 'magnific-popup'
import './classes/polyfills.class.js'
import AnchorScroller from './classes/anchor-scroller'
import AOS from 'aos'
import CollapsibleItem from './classes/collapsible-item.class.js'
import FixedHeader from './classes/fixed-header.class'
import FixedIsi from './classes/fixed-isi.js'
import FormBehavior from './classes/form-behavior.class.js'
import MainMenu from './classes/main-menu.class.js'
import Carousel from './classes/carousel.class.js'
import Modal from './classes/modal.class.js'
import Violator from './classes/violator.class'
import CategoryPiece from './classes/select-category-piece.class'
import StatsCarousel from './classes/stats-carousel.class'
import AudienceModal from './classes/audience-modal.class.js'
import ScrollableTable from './classes/scrollable-table.class'
import './classes/external-links'
import './classes/pdf-links'
import './classes/events'


// Initialize AnchorScroller
const scroll = new AnchorScroller(
  106,
  59,
  // 0,0,
  1025
)
scroll.init()

$(window).on('resize', function () {
  if ($('html').hasClass('enable_sticky_desktop')) {
    scroll.desktopOffset = $('header[role=banner]').height()
  }

  if ($('html').hasClass('enable_sticky_desktop')) {
    scroll.mobileOffset = $('header[role=banner]').height()
  }
}).trigger('resize')



$(() => {

  // Initialize Animate on Scroll
  AOS.init({
    duration: 1200,
    once: true
  })

  setTimeout(() => {
    AOS.refresh()
  }, 1000)

  // Initialize Modal Class
  new AudienceModal()
  new Modal()

  const isi = document.querySelector('.isi .fixed')
  if (isi) {
    new FixedIsi()
  }

  const violator = document.querySelector('.violator')
  if (violator) {
    new Violator(violator)
  }

  new FixedHeader()

  const mainMenu = document.querySelector('.layout-container > header')
  if (mainMenu) {
    new MainMenu(mainMenu)
  }
  if ($('.scrollable-table').length) {
    new ScrollableTable($('.scrollable-table')[0])
  }
  if (
    $('.steps-carousel').length
    && !$('.node-page-layout-builder-form').length
  ) {
    $.uniqueSort(
      $('.steps-carousel')
        .parents('.layout__region')
    )
      .css({
        'min-width': 0
      })
      .each(function () {
        new Carousel(this, {
          accessibility: true,
          lazyLoad: 'ondemand',
          arrows: false,
          dots: true,
          speed: 1000,
          mobileFirst: true,
          adaptiveHeight: true,
          autoplay: false
        })
      })
  }
  if ($('.night-day-slide').length
      && !$('.node-page-layout-builder-form').length
  ) {
    $.uniqueSort(
      $('.night-day-slide')
        .parents('.layout__region')
    )
      .css({
        'min-width': 0
      })
      .each(function () {
        new Carousel(this, {
          accessibility: true,
          arrows: false,
          // dots: true,
          speed: 1000,
          mobileFirst: true,
          fade: true,
          autoplay: true,
          pauseOnHover: false
        })
      })
  }

  if ($('.category-piece').length
      && !$('.node-page-layout-builder-form').length
  ) {
    new CategoryPiece($('.category-piece')[0], {
      accessibility: true,
      arrows: false,
      speed: 1000,
      mobileFirst: true,
      fade: true,
      pauseOnHover: false,
      swipe: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            adaptiveHeight: false
          }
        }
      ]
    })
  }
  if ($('.stats-carousel').length
    && !$('.node-page-layout-builder-form').length
  ) {
    new StatsCarousel($('.stats-carousel')[0], {
      accessibility: true,
      arrows: false,
      speed: 1000,
      mobileFirst: true,
      fade: true,
      pauseOnHover: false,
      swipe: false
    })
  }
  const getInTouchFormInTray = document.querySelector('footer .webform-submission-get-in-touch-form')

  if (getInTouchFormInTray !== null) {
    const formTray = document.querySelector('#block-getintouchformtray')
    new FormBehavior(getInTouchFormInTray, () => {
      formTray.classList.add('submitted')
    })
  }

  if (document.documentElement.classList.contains('contact')) {
    console.log('contact page')
    const form = document.querySelector('.webform-submission-get-in-touch-form')
    new FormBehavior(form, () => {
      document.documentElement.classList.add('submitted')
      window.scrollTo(0, 0)
    })
  }
  if (document.documentElement.classList.contains('unsubscribe')) {
    console.log('unsubscribe page')
    const form = document.querySelector('.webform-submission-unsubscribe-form')
    new FormBehavior(form, () => {
      document.documentElement.classList.add('submitted')
      window.scrollTo(0, 0)
    })
  }
  document.querySelectorAll('.block--type--collapsible-item').forEach(item => {
    new CollapsibleItem(item)
  })

  if ($('.popup-youtube').length) {
    $('.popup-youtube').magnificPopup({
      type: 'iframe',
      iframe: {
        patterns: {
          youtube: {
            index: 'youtube.com/',
            id: 'v=',
            src: '//www.youtube.com/embed/%id%?autoplay=1&modestbranding=1'
          }
        }
      },
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    })
  }
})



// WEBPACK FOOTER //
// ./js/main.js